import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const h = (n) => `${(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 2 })} h`;
const shift = (ym, d) => { const [y, m] = ym.split("-").map(Number); const t = new Date(y, m - 1 + d, 1); return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}`; };
const label = (ym) => { const [y, m] = ym.split("-").map(Number); const s = new Date(y, m - 1, 1).toLocaleDateString("it-IT", { month: "long", year: "numeric" }); return s[0].toUpperCase() + s.slice(1); };

export const OperatorMonth = ({ sheets }) => {
  const [ym, setYm] = useState(() => new Date().toLocaleDateString("sv-SE").slice(0, 7));
  const tot = {};
  sheets.filter((s) => (s.date || s.created_at || "").startsWith(ym)).forEach((s) => { tot[s.operator] = (tot[s.operator] || 0) + (s.total_hours || 0); });
  const rows = Object.entries(tot).sort((a, b) => b[1] - a[1]);
  const nav = (d) => (
    <button onClick={() => setYm(shift(ym, d))} className="p-1.5 rounded-full hover:bg-white/10" aria-label={d < 0 ? "Mese precedente" : "Mese successivo"} data-testid={`operator-month-${d < 0 ? "prev" : "next"}`}>
      {d < 0 ? <ChevronLeft className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
    </button>
  );
  return (
    <section data-testid="operator-month">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <h3 className="font-display font-bold uppercase text-sm mr-auto">Ore per operatore nel mese</h3>
        <div className="flex items-center">{nav(-1)}<span className="min-w-[130px] text-center text-sm font-semibold" data-testid="operator-month-label">{label(ym)}</span>{nav(1)}</div>
      </div>
      {rows.length === 0 ? <p className="text-sm text-muted-foreground" data-testid="operator-month-empty">Nessuna ora registrata in questo mese.</p> : (
        <div className="rounded-xl border border-white/10 bg-[#181A22] divide-y divide-white/5">
          {rows.map(([name, hrs], i) => (
            <div key={name} className="flex items-center justify-between px-4 py-2.5 text-sm" data-testid={`operator-month-row-${i}`}>
              <span className="font-semibold">{name}</span><span className="font-bold text-[#FF9E00]">{h(hrs)}</span>
            </div>
          ))}
          <div className="flex items-center justify-between px-4 py-2.5 text-sm text-muted-foreground"><span>Totale mese</span><span className="font-bold text-white" data-testid="operator-month-total">{h(rows.reduce((a, [, v]) => a + v, 0))}</span></div>
        </div>
      )}
    </section>
  );
};
